(function () {
  const translations = {
    // Modal titles
    'Cancellation policy': 'Atcelšanas politika',
    'Cancellation Policy': 'Atcelšanas politika',

    // Section headings
    'Subscriptions': 'Abonementi',
    'Pre-orders': 'Iepriekšpasūtījumi',
    'Try before you buy': 'Izmēģini pirms pirkšanas',

    // Intro
    'Some items in our store may be offered to you as a subscription, a pre-order or try before you buy.':
      'Dažas preces mūsu veikalā var tikt piedāvātas kā abonements, iepriekšpasūtījums vai iespēja izmēģināt pirms pirkšanas.',

    'This cancellation policy lays out how you can change or cancel these kinds of purchases.':
      'Šī atcelšanas politika nosaka, kā jūs varat mainīt vai atcelt šāda veida pirkumus.',

    // Subscriptions
    "When you purchase a subscription you'll receive repeat deliveries.":
      'Iegādājoties abonementu, jūs saņemsiet regulāras piegādes.',

    'These are based on the subscription duration and frequency that you select.':
      'Tās tiek veiktas atbilstoši jūsu izvēlētajam abonementa termiņam un piegādes biežumam.',

    "Your payment details will be stored securely and you'll be charged for each of these deliveries, unless you choose to pay in advance.":
      'Jūsu maksājuma dati tiks droši saglabāti, un maksa tiks iekasēta par katru piegādi, ja vien neizvēlēsieties samaksāt iepriekš.',

    'Some subscriptions may auto-renew at the end of their duration.':
      'Daži abonementi var tikt automātiski atjaunoti pēc to termiņa beigām.',

    "If you don't want to renew a subscription you can cancel it.":
      'Ja nevēlaties atjaunot abonementu, varat to atcelt.',

    'If you want to cancel or change your subscription, you can do it at any time.':
      'Ja vēlaties atcelt vai mainīt abonementu, to varat izdarīt jebkurā laikā.',

    'Your order confirmation emails have links to your order.':
      'Pasūtījuma apstiprinājuma e-pastos ir saites uz jūsu pasūtījumu.',

    'You can manage your subscription from there.':
      'No turienes varat pārvaldīt savu abonementu.',

    'See our returns policy for more details on returns and refunds.':
      'Plašāku informāciju par preču atgriešanu un naudas atmaksu skatiet mūsu atgriešanas politikā.',

    // Pre-orders
    'When you purchase a pre-order, you are buying an out-of-stock or soon-to-be-available product not yet in inventory.':
      'Veicot iepriekšpasūtījumu, jūs iegādājaties preci, kas pašlaik nav noliktavā vai drīzumā būs pieejama.',

    'We may collect no payment or a partial deposit at checkout, store your payment method, then fulfill and charge the full or remaining payment at a future date.':
      'Mēs varam neiekasēt maksu vai iekasēt tikai daļēju depozītu pasūtījuma veikšanas brīdī, saglabāt jūsu maksājuma informāciju un pilnu vai atlikušo summu iekasēt vēlāk.',

    'You can cancel a partially paid pre-order order that has not yet been fulfilled.':
      'Jūs varat atcelt daļēji apmaksātu iepriekšpasūtījumu, ja tas vēl nav izpildīts.',

    "If the order has been fulfilled, then you can't cancel the order, but you can request a full or partial refund.":
      'Ja pasūtījums jau ir izpildīts, to vairs nevar atcelt, taču jūs varat pieprasīt pilnu vai daļēju naudas atmaksu.',

    // Try before buy
    'When you purchase a try before you buy item, we authorize your payment method before fulfilling the order.':
      'Iegādājoties preci ar iespēju izmēģināt pirms pirkšanas, mēs autorizējam jūsu maksājuma veidu pirms pasūtījuma izpildes.',

    'You will have a certain amount of time to decide if you want to keep the item.':
      'Jums būs noteikts laiks, lai izlemtu, vai vēlaties preci paturēt.',

    'Once the time period has passed, if you have not returned the item, we will charge your payment method for the full amount.':
      'Kad noteiktais periods būs beidzies un prece nebūs atgriezta, mēs iekasēsim pilnu summu no jūsu maksājuma veida.',

    // Buyer consent
    'This item is a deferred, subscription, or recurring purchase.':
      'Šī prece ir atlikts, abonēšanas vai atkārtots pirkums.',

    'By continuing, I agree to the':
      'Turpinot, es piekrītu',

    'cancellation policy':
      'atcelšanas politikai',

    'and authorize you to charge my payment method at the prices, frequency and dates listed on this page until my order is fulfilled or I cancel, if permitted.':
      'un pilnvaroju jūs iekasēt maksu no mana maksājuma veida saskaņā ar šajā lapā norādītajām cenām, biežumu un datumiem, līdz mans pasūtījums ir izpildīts vai es to atceļu, ja tas ir atļauts.'
  };

  const entries = Object.entries(translations)
    .sort((a, b) => b[0].length - a[0].length);

  function translateText(text) {
    let result = text;

    entries.forEach(([en, lv]) => {
      result = result.replaceAll(en, lv);
    });

    return result;
  }

  function translateElement(element) {
    if (!element) return;

    // Translate title attribute
    if (element.hasAttribute('title')) {
      const title = element.getAttribute('title');
      const translated = translateText(title);

      if (translated !== title) {
        element.setAttribute('title', translated);
      }
    }

    // Translate HTML content
    const html = element.innerHTML;
    const translatedHtml = translateText(html);

    if (translatedHtml !== html) {
      element.innerHTML = translatedHtml;
    }
  }

  function runTranslations() {
  // Regular DOM translations
  document.querySelectorAll('top-level-modal').forEach(translateElement);
  document.querySelectorAll('#shopify-buyer-consent').forEach(translateElement);

  // Shadow DOM modal translations
  document.querySelectorAll('top-level-modal').forEach((modal) => {
    if (!modal.shadowRoot) return;

    // Translate entire modal HTML
    const walker = document.createTreeWalker(
      modal.shadowRoot,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    let node;

    while ((node = walker.nextNode())) {
      const original = node.textContent;

      if (!original || !original.trim()) continue;

      const translated = translateText(original);

      if (translated !== original) {
        node.textContent = translated;
      }
    }

    // Force modal title translation
    const title = modal.shadowRoot.querySelector('#modal h2#title span');

    if (
      title &&
      (
        title.textContent.trim() === 'Cancellation policy' ||
        title.textContent.trim() === 'Cancellation Policy'
      )
    ) {
      title.textContent = 'Atcelšanas politika';
    }


    // Force close button translation
    const closeBtn = modal.shadowRoot.querySelector('[aria-label="Close"]');

    if (closeBtn) {
      closeBtn.setAttribute('aria-label', 'Aizvērt');
    }
  });
}

  runTranslations();

  const observer = new MutationObserver(() => {
    runTranslations();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  console.log('✅ Shopify Latvian translations loaded');
})();